<template>
    <div>
        <section class="folders-section section py-5 px-5">
            <p class="px-3 is-size-4 has-text-black">
                <span class="">{{$t('entity_stats')}}</span>
            </p>
            <p class="px-3 is-size-6 has-text-eduloc-grey secondary-font">
                <span class="">{{$t('entity_stats_description')}}</span>
            </p>
        </section>

        <!--<section class="section pt-5 px-5 pb-2">
            <div class="px-3 columns is-mobile is-multiline">
                <div class="column is-narrow">
                    <div class="stats-left">
                        {{$t('entity_stats_total_visits')}}
                    </div>
                    <div class="stats-right">
                        {{ totalVisites }}
                    </div>
                </div>
                <div class="column is-narrow">
                    <div class="stats-left blue">
                        {{$t('entity_stats_total_project_visits')}}
                    </div>
                    <div class="stats-right blue">
                        {{ nombreTotalVisitesProjecte }}
                    </div>
                </div>
                <div class="column is-narrow">
                    <div class="stats-left yellow">
                        {{$t('entity_stats_total_game_visits')}}
                    </div>
                    <div class="stats-right yellow">
                        {{ nombreTotalvisitesJocs }}
                    </div>
                </div>
                <div class="column is-narrow">
                    <div class="stats-left">
                        {{$t('entity_stats_total_participation')}}
                    </div>
                    <div class="stats-right">
                        {{ nombreTotalJugadors }}
                    </div>
                </div>
                <div class="column is-narrow">
                    <div class="stats-left blue">
                        {{$t('entity_stats_app_list_views')}}
                    </div>
                    <div class="stats-right blue">
                        {{ generalStats.appListViews }}
                    </div>
                </div>
            </div>
        </section>-->

        <section class="section pt-5 px-5 pb-2">
            <span class="px-3 is-size-5 has-text-black">{{$t('entity_stats_project')}}</span>
        </section>
        
        <section ref="searchBox" class="section pt-0 px-5 pb-6">
            <div class="mx-3">
                <dashboard-app-content-search
                    v-model="projectTextSearch"
                    :availablefilters="projectFilters"
                    :switch-mode="true"
                    :default-switch-mode-name="'LIST_MODE'"
                    :hasOrder="true"
                    :availableOrder="availableOrder"
                    :availableProjectTypes="typeProjects"
                    @change-filter="changeProjectFilter"
                    @change-project-type="changeProjectType"
                    @change-order="changeProjectOrder"
                    :loading="loading"
                    class=""
                />
            </div>
        </section>

        
        <section ref="contentBox" class="section pt-0 px-5" >
            <management-entity-stats-project
                v-if="filteredProjects.length"
                :projects="filteredProjects"
                :showCreationCard="false" 
                :showMode="showMode"
                @deleteProject="removeProject"
                @addProject="addProject"
            />
            <p
                v-else-if="!loading"
                v-t="'no_content_to_show'"
                class="notification is-eduloc-yellow mx-3"
            ></p>
        </section>

        <section class="section pt-5 px-5 pb-2">
            <span class="px-3 is-size-5 has-text-black">{{$t('entity_stats_game')}}</span>
        </section>
        
        <section ref="searchBox" class="section pt-0 px-5 pb-6">
            <div class="mx-3">
                <dashboard-app-content-search
                    v-model="gameTextSearch"
                    :availablefilters="gameFilters"
                    :switch-mode="false"
                    :default-switch-mode-name="'LIST_MODE'"
                    :hasOrder="true"
                    :availableOrder="availableGameOrder"
                    :availableProjectTypes="gameTypeProjects"
                    @change-filter="changeGameFilter"
                    @change-project-type="changeGameType"
                    @change-order="changeGameOrder"
                    :loading="loading"
                    class=""
                />
            </div>
        </section>

        
        <section ref="contentBox" class="section pt-0 px-5" >
            <management-entity-stats-game
                v-if="filteredGames.length"
                :projects="filteredGames"
                :showCreationCard="false" 
                :showMode="showMode"
            />
            <p
                v-else-if="!loading"
                v-t="'no_content_to_show'"
                class="notification is-eduloc-yellow mx-3"
            ></p>
        </section>
    </div>
</template>

<script>
import { fetchEntityProjectStats,fetchEntityGameStats, fetchEntityGeneralStats } from '@/services/API';
import DashboardAppContentSearch from '@/components/DashboardAppContentSearch';
import ManagementEntityStatsProject from '@/components/ManagementEntityStatsProject';
import ManagementEntityStatsGame from '@/components/ManagementEntityStatsGame';
import { Document } from 'flexsearch';
import _ from 'underscore';

export default {
    components: {
        DashboardAppContentSearch,
        ManagementEntityStatsProject,   
        ManagementEntityStatsGame
    },
    data() {
        return {
            projectContent: [],
            gameContent: [],
            loading: false,
            projectTextSearch: "",
            gameTextSearch: "",
            typeSearch: 'PROJECT_TYPE_ALL',
            gameTypeSearch: 'PROJECT_TYPE_ALL',
            filterSearch: 'APP_ALL',
            projectOrder: 'CREATED_DESC',
            gameOrder: 'CREATED_DESC',
            projectSearchIndex: new Document({
                resolution: 3,
                tokenize: 'full',
                document: {
                    id: '_id',
                    index: [
                        {
                            field: 'title',
                            minlength: 0,
                        },
                    ],
                },
            }),
            gameSearchIndex: new Document({
                resolution: 3,
                tokenize: 'full',
                document: {
                    id: '_id',
                    index: [
                        {
                            field: 'title',
                            minlength: 0,
                        },
                    ],
                },
            }),
            projectFilters: [
                'APP_ALL',
                'GAME_ACTIVE',
                'GAME_FINISHED'
            ],
            gameFilters: [
                'APP_ALL',
                'GAME_ACTIVE',
                'GAME_FINISHED'
            ],
            typeProjects: [
                "PROJECT_TYPE_WALL",
                "PROJECT_TYPE_MAP",
            ],
            gameTypeProjects: [
                "PROJECT_TYPE_QUIZ",
                "PROJECT_TYPE_QUIZHUNT",
                "PROJECT_TYPE_GEOQUIZ",
                "PROJECT_TYPE_TREASUREHUNT",
                "PROJECT_TYPE_MEMORY"
            ],
            showMode: 'LIST_MODE',
            availableOrder: [
                'CREATED_ASC',
                'CREATED_DESC',
                'VISITS_ASC',
                'VISITS_DESC'
            ],
            availableGameOrder: [
                'CREATED_ASC',
                'CREATED_DESC',
                'VISITS_ASC',
                'VISITS_DESC',
                'JUGADORS_ASC',
                'JUGADORS_DESC'
            ],
            nombreTotalVisitesProjecte: 0,
            nombreTotalvisitesJocs: 0,
            nombreTotalJugadors: 0,
            generalStats: [],
        };
    },
    computed: {
        totalVisites() {
            return this.nombreTotalVisitesProjecte + this.nombreTotalvisitesJocs + this.nombreTotalJugadors;
        },
        textFilteredProjects() {
            // console.log("textSearch",this.textSearch)
            if (this.projectTextSearch) {
                this.rebuildProjectIndex();
                this.projectContent.forEach((item) => {
                    this.projectSearchIndex.add(item);
                });
                const result = this.projectSearchIndex.search(this.projectTextSearch);
                // console.log(this.textSearch, result);
                const ids = _.chain(result).pluck('result').flatten().value();
                // console.log('ids', ids);
                return this.projectContent.filter((item) => {
                    return _.contains(ids, item._id);
                });
            }
            return this.projectContent;
        },
        filteredProjects() {
            // console.log("filtering projects")
            let projects = this.textFilteredProjects;
            // console.log(projects)
            let inFilters = [];
            let inType = [];

            if(this.typeSearch){
                if(this.typeSearch!='PROJECT_TYPE_ALL'){
                    inType =
                        _.filter(
                            this.textFilteredProjects,
                            (project) => {
                                if (project.project) {
                                    return project.project.format == this.typeSearch
                                } else {
                                    return project.format == this.typeSearch
                                }
                            }
                        );
                }else{
                    inType = projects;
                }
                
            }

            if (inType.length) {
                projects = _.uniq(_.intersection(projects, inType));
            }else{
                projects = [];
            }


            

            if(this.projectOrder){
                let orderedProjects;
                // console.log('ordening',this.projectOrder)
                switch(this.projectOrder){
                    case 'CREATED_DESC':
                        orderedProjects = _.sortBy(projects, function(o) { 
                            return o.created; 
                            });
                        break;
                    case 'CREATED_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.created; }).reverse();
                        break;
                    case 'VISITS_ASC':
                        // console.log("erwr")
                        orderedProjects = _.sortBy(projects, function (o) { return o.viewsFromApp; }).reverse();
                        break;
                    case 'VISITS_DESC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.viewsFromApp; });
                        break;
                    /*case 'MODIFIED_DESC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.modified; });
                        break;
                    case 'MODIFIED_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.modified; }).reverse();
                        break;
                    case 'TITLE_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.title; });
                        break;
                    case 'AUTHOR_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.owner.username; });
                        break;
                    case 'TYPE_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.format; });
                        break;*/
                    default: 
                        orderedProjects = _.sortBy(projects, function(o) { return o.created; });
                        break;
                }
                projects = orderedProjects;
            }
            return projects;
        },

        textFilteredGames() {
            // console.log("textSearch",this.textSearch)
            if (this.gameTextSearch) {
                this.rebuildGameIndex();
                this.gameContent.forEach((item) => {
                    this.gameSearchIndex.add(item);
                });
                const result = this.gameSearchIndex.search(this.gameTextSearch);
                // console.log(this.textSearch, result);
                const ids = _.chain(result).pluck('result').flatten().value();
                // console.log('ids', ids);
                return this.gameContent.filter((item) => {
                    return _.contains(ids, item._id);
                });
            }
            // console.log("gameContent",this.gameContent)
            return this.gameContent;
        },
        filteredGames() {
            // console.log("filtering projects")
            let games = this.textFilteredGames;
            // console.log(projects)
            let inFilters = [];
            let inType = [];

            if(this.gameTypeSearch){
                if(this.gameTypeSearch!='PROJECT_TYPE_ALL'){
                    inType =
                        _.filter(
                            this.textFilteredGames,
                            (game) => {
                                if (game.project) {
                                    return game.project.format == this.gameTypeSearch
                                } else {
                                    return game.format == this.gameTypeSearch
                                }
                            }
                        );
                }else{
                    inType = games;
                }
                
            }

            if (inType.length) {
                games = _.uniq(_.intersection(games, inType));
            }else{
                games = [];
            }

            if(this.gameOrder){
                let orderedGames;
                // console.log(' game ordening',this.gameOrder)
                switch(this.gameOrder){
                    case 'CREATED_DESC':
                        orderedGames = _.sortBy(games, function(o) { 
                            return o.created; 
                            });
                        break;
                    case 'CREATED_ASC':
                        orderedGames = _.sortBy(games, function(o) { return o.created; }).reverse();
                        break;
                    case 'VISITS_ASC':
                        // console.log("erwr")
                        orderedGames = _.sortBy(games, function (o) { return o.usuarisTotals; }).reverse();
                        break;
                    case 'VISITS_DESC':
                        orderedGames = _.sortBy(games, function(o) { return o.usuarisTotals; });
                        break;
                    case 'JUGADORS_ASC':
                        orderedGames = _.sortBy(games, function (o) { return o.jugadors; }).reverse();
                        break;
                    case 'JUGADORS_DESC':
                        orderedGames = _.sortBy(games, function(o) { return o.jugadors; });
                        break;
                    /*case 'MODIFIED_DESC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.modified; });
                        break;
                    case 'MODIFIED_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.modified; }).reverse();
                        break;
                    case 'TITLE_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.title; });
                        break;
                    case 'AUTHOR_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.owner.username; });
                        break;
                    case 'TYPE_ASC':
                        orderedProjects = _.sortBy(projects, function(o) { return o.format; });
                        break;*/
                    default: 
                        orderedGames = _.sortBy(games, function(o) { return o.created; });
                        break;
                }
                games = orderedGames;
            }
            return games;
        },








        /*projectType() {
            if (
                this.selectedType ==
                this.$t('Constants.FILTER_OPTION_PROJECTS_COLLECTIONS')
            ) {
                return 'collection,map';
            } else if (
                this.selectedType ==
                this.$t('Constants.FILTER_OPTION_PROJECTS_GAMES')
            ) {
                return 'trivial,treasurehunt,scape,memory,quizhunt';
            }
            return 'collection,trivial,treasurehunt,storytelling,scape,memory,quizhunt';
        },
        handleDebouncedScroll() {
            return _.debounce(this.handleScroll, 100);
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        showNoProjects(){
            return !this.projects.length && !this.searchString && this.selectedType=='FILTER_OPTION_PROJECTS_ALL'
        }*/
    },
    watch: {
        projectContent: {
            handler: function () {
                this.projectContent.forEach((item) => {
                    this.projectSearchIndex.add(item);
                });
            },
            immediate: true,
            deep: true,
        },
        gameContent: {
            handler: function () {
                this.gameContent.forEach((item) => {
                    this.gameSearchIndex.add(item);
                });
            },
            immediate: true,
            deep: true,
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleDebouncedScroll, true);

        this.loading = true;
        fetchEntityProjectStats().then(({ data }) => {
            this.projectContent = data;
            this.loading = false;
            this.projectContent.forEach((project) => { 
                this.nombreTotalVisitesProjecte += project.viewsFromApp;
            })
        });
        fetchEntityGameStats().then(({ data }) => {
            this.gameContent = data;
            this.loading = false;
            // console.log("game data",data)
            this.gameContent.forEach((game) => { 
                this.nombreTotalvisitesJocs += game.usuarisTotals;
                this.nombreTotalJugadors += game.jugadors;
                
            })
        });
        fetchEntityGeneralStats().then(({ data }) => {
            this.generalStats = data;
            this.loading = false;
            // console.log("game data",data)
        });
        
        
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleDebouncedScroll);
    },
    methods: {
        toggleListed(project) {
            //this.$emit("toggleHighlight",project)
            const updatedIndex = _.findIndex(this.content, {
                _id: project._id,
            });

            this.content.splice(updatedIndex, 1, project);
        },
        changeProjectFilter(e){
            // console.log("change filter",e)
            this.projectFilterSearch=e;
        },
        changeGameFilter(e){
            // console.log("change filter",e)
            this.gameFilterSearch=e;
        },
        changeProjectType(e){
            // console.log("change project type",e)
            this.typeSearch=e;
        },
        changeGameType(e){
            // console.log("change project type",e)
            this.gameTypeSearch=e;
        },
        changeProjectOrder(e){
            //console.log("change order",e)
            this.projectOrder=e;
        },
        changeGameOrder(e){
            //console.log("change order",e)
            this.gameOrder=e;
        },
        rebuildProjectIndex() {
            let projects = this.projectContent;
            this.projectSearchIndex.remove(projects);
        },
        rebuildGameIndex() {
            let games = this.gameContent;
            this.gameSearchIndex.remove(games);
        },
        changeMode(e) {
            // console.log("change show mode",e)
            this.showMode = e;
        },
        removeProject(_id) {
            // console.log('removing item', _id);
            this.content = _.filter(this.content, (item) => {
                return item._id != _id;
            });
        },
        addProject(project) {
            // console.log('dashboardProjects', project);
            this.content.push(project);
            //this.resetSearch();
        },
        resetSearch() {
            this.content = [];
            this.loading = true;
            fetchEntityStats().then(({ data }) => {
                this.content = data;
                this.loading = false;
            });
        },
        
        










        
    },
};
</script>

<style scoped>
.hide {
    visibility: hidden !important;
    height: 0px;
    width: 0px;
    overflow: hidden;
}
.show {
    height: auto;
    overflow: hidden;
}
.is-horizontally-centered {
    margin: 0 auto;
}
.lb-creation-object .icon.is-large {
    height: 10rem;
    width: 10rem;
}
.mdi-10r {
    font-size: 10rem;
}

.back-image{
    padding-top: 5rem;
    max-width: 45%;
}
.stats-left{
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    background-color: var(--eduloc-red);
    color: #FFFFFF;
    text-align: left;
    display: inline-block;
    padding: 0.5rem;
    border-color: var(--eduloc-red);
    border-width: 1px;
}
.stats-right{
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    background-color: #FFFFFF;
    color: #000000;
    text-align: center;
    display: inline-block;
    padding: 0.5rem;
    border-color: var(--eduloc-red);
    border-width: 1px;
}
.stats-left.blue{
    background-color: var(--eduloc-blue);
    color: #FFFFFF;
    border-color: var(--eduloc-blue);
    border-width: 1px;
}
.stats-right.blue{
    background-color: #FFFFFF;
    color: #000000;
    border-color: var(--eduloc-blue);
    border-width: 1px;
}
.stats-left.yellow{
    background-color: var(--eduloc-yellow);
    color: #FFFFFF;
    border-color: var(--eduloc-yellow);
    border-width: 1px;
}
.stats-right.yellow{
    background-color: #FFFFFF;
    color: #000000;
    border-color: var(--eduloc-yellow);
    border-width: 1px;
}
</style>
